<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="`Ingressos ${party?.name} - ${ticket?.id?.slice(0, 8)}`"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width=""
      @progress="onProgress($event)"
      @error="onError($event)"
      @beforeDownload="beforeDownload"
      ref="html2Pdf"
    >
      <section class="v-application" slot="pdf-content">
        <v-theme-provider light>
          <div class="d-flex flex-column">
            <export-ticket
              :ticket="ticket"
              :user="user"
              :images="images"
              :party="party"
              :fullAddress="fullAddress"
              :geometry="geometry"
              :share="share"
            />
          </div>
        </v-theme-provider>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import ExportTicket from "@/components/app/myTickets/ExportTicket.vue";
import TICKET from "@/services/app/ticket";
import VueHtml2pdf from "vue-html2pdf";
import { mapGetters } from "vuex";
export default {
  components: { ExportTicket, VueHtml2pdf },
  data: () => ({
    dialog: false,
    ticket: null,
    images: {
      partyId: null,
      cover: null,
      favicon: null,
    },
    share: null,
  }),
  methods: {
    async blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const dataUrl = reader.result;
          resolve(dataUrl);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(blob);
      });
    },
    async downloadImageAsBase64(url) {
      try {
        const blob = await this.downloadImage(url);
        return await this.blobToBase64(blob);
      } catch (error) {
        console.error("Erro ao baixar a imagem:", error);
        throw error;
      }
    },
    async downloadImage(url) {
      const response = await fetch(url);
      return await response.blob();
    },
    async downloadPartyCover() {
      const response = await TICKET.getCover(this.ticket.id);
      return response.base64;
    },
    async downloadContent() {
      if (this.party.id === this.images.partyId) return;
      const coverBase64 = await this.downloadPartyCover();
      const favicon = await this.downloadImageAsBase64("/favicon.png");
      this.images = {
        partyId: this.party.id,
        cover: coverBase64,
        favicon: favicon,
      };
    },
    async registerShare(name) {
      const response = await TICKET.share(this.ticket.id, {
        name: name,
      });
      return response.share;
    },
    async generatePDF({ ticket, shareName }) {
      const promise = new Promise(async (resolve, reject) => {
        try {
          this.ticket = ticket;
          this.promise = { resolve, reject };

          await this.downloadContent();
          if (typeof shareName === "string") {
            const share = await this.registerShare(shareName);
            this.share = share;
          }

          this.$refs.html2Pdf.generatePdf();
        } catch (error) {
          reject(error);
        }
      });
      return promise;
    },
    onProgress(progress) {
      console.log("PDF Progress: ", progress);
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      var html2PdfSetup = html2pdf().set(options).from(pdfContent);
      var pdf = await html2PdfSetup.output("blob");
      this.promise.resolve(pdf);
    },
    onError(error) {
      console.log("PDF Error: ", error);
      this.promise.reject(error);
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),

    geometry() {
      if (!this.party?.Address?.lat || !this.party?.Address?.lng) return null;
      return {
        lat: this.party.Address.lat,
        lng: this.party.Address.lng,
      };
    },
    fullAddress() {
      if (!this.party?.Address) return "";
      const addrs = this.party.Address;
      var address = "";
      if (this.party.locationReveled) {
        if (addrs.street) {
          address += `${addrs.street}`;
          if (addrs.number) address += `, ${addrs.number}`;
        }
        if (addrs.neighborhood) address += ` - ${addrs.neighborhood}`;
        if (addrs.complement) address += ` - ${addrs.complement}`;
        if (address) address += ` - `;
        address += `${addrs.city} - ${addrs.state}`;
        if (addrs.zipCode) address += ` - ${addrs.zipCode}`;
      } else {
        address = `${addrs.city} - ${addrs.state}`;
      }

      return address;
    },
    obfuscatedCPF() {
      return this.user.document
        .replace(/\D/g, "")
        .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.***.***-$4");
    },
  },
  props: {
    party: {
      type: Object,
      default: () => null,
    },
  },

  mounted() {
    this.$parent.$on("openExport", this.open);
  },
};
</script>

<style></style>
